import { InjectionToken } from '@angular/core';

export const AppVersion = new InjectionToken('App Version');
